import { HttpStatusCode } from '../enums';
import { Deserializable } from './deserializable.model';

export enum Status {
  /// Beginning the download process
  starting,

  /// This is data from the local database or cache
  local,

  /// Remote data has finished downloading
  done,

  /// Error retrieving data
  error,
}

export class DataStatus<T> {
  /// Data retrieval status
  status: Status;

  /// Error message from the server
  message: StatusMessage;

  /// Data retrieved from the server or local storage
  data: T;

  constructor();
  constructor(status: Status, message: StatusMessage, data: T);
  constructor(status?: Status, message?: StatusMessage, data?: T) {
    this.status = status;
    this.message = message;
    this.data = data;
  }
}

export class StatusMessage implements Deserializable<any, StatusMessage> {
  code: number;
  message: string;

  constructor(code, message) {
    this.code = code;
    this.message = message;
  }

  static generic() {
    return new StatusMessage(HttpStatusCode.INTERNAL_SERVER_ERROR, 'Unknown error');
  }

  /**
   * Assigns the Gets a generic initial StatusMessage params with presets if nothing passed
   */
  static initial(code?: number, message?: string) {
    return new StatusMessage(code || HttpStatusCode.OK, message || 'OK');
  }

  /**
   * Assigns the StatusMessage params from JSON
   */
  deserialize(json: any): StatusMessage {
    Object.assign(this, json);
    if (!this.code) {
      // fallback status
      this.code = HttpStatusCode.INTERNAL_SERVER_ERROR;
    }
    return this;
  }
}
